import axios from 'axios'

export interface AttemptFilters {
  national_id?: string
  country?: string
  success?: boolean
  start_date?: string
  end_date?: string
  page?: number
  size?: number
}

export async function fetchAttempts(filters: AttemptFilters){
  const params: any = { ...filters }
  return axios.get('/api/v1/biometric/attempts', { params })
}

export async function fetchStats(params: { start_date?: string, end_date?: string }){
  return axios.get('/api/v1/biometric/stats', { params })
}

export async function fetchStatsBreakdown(params: { start_date?: string, end_date?: string }){
  return axios.get('/api/v1/biometric/stats/breakdown', { params })
}
